module.exports = __webpack_public_path__ + "img/feature-1.02550a2.png";